import React from 'react';
const CameraSVG = ({ color = 'black', className }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 1437252881">
        <circle
          id="Ellipse 40"
          cx="20"
          cy="20"
          r="19"
          fill={color}
          stroke="white"
          strokeWidth="2"
        />
        <g id="Group 1437252880">
          <path
            id="Vector"
            d="M28.8378 27H11.7722C11.5674 27 11.371 26.9186 11.2262 26.7738C11.0814 26.629 11 26.4326 11 26.2278V16.0888C11 15.6602 11.3436 15.7027 11.7722 15.7027H14.6834C14.7392 15.7027 14.7943 15.6906 14.8449 15.6673C14.8956 15.644 14.9406 15.6099 14.9768 15.5676L16.5598 13.2703C16.6323 13.1855 16.7223 13.1175 16.8237 13.0708C16.925 13.0241 17.0352 13 17.1467 13H23.3938C23.5047 13.0005 23.6142 13.025 23.7148 13.0716C23.8154 13.1182 23.9048 13.186 23.9768 13.2703L25.5637 15.5676C25.6 15.6099 25.645 15.644 25.6956 15.6673C25.7463 15.6906 25.8014 15.7027 25.8571 15.7027H28.8378C29.2664 15.7027 29.61 15.6602 29.61 16.0888V26.2278C29.61 26.4326 29.5287 26.629 29.3839 26.7738C29.239 26.9186 29.0426 27 28.8378 27Z"
            stroke="white"
            strokeWidth="1.2"
          />
          <path
            id="Vector_2"
            d="M20.3051 24.6527C22.4481 24.6527 24.1854 22.9154 24.1854 20.7724C24.1854 18.6294 22.4481 16.8921 20.3051 16.8921C18.1621 16.8921 16.4248 18.6294 16.4248 20.7724C16.4248 22.9154 18.1621 24.6527 20.3051 24.6527Z"
            stroke="white"
            strokeWidth="1.2"
          />
        </g>
      </g>
    </svg>
  );
};

export default CameraSVG;
